/* ---------- gallery ---------- */
var slides=document.querySelectorAll('#productImages .slide');
document.querySelectorAll('#sliderThumb > div').forEach(function(t,i){
  t.addEventListener('click',function(){
    document.querySelectorAll('#sliderThumb > div').forEach(function(x){x.classList.remove('current');});
    slides.forEach(function(s){s.classList.remove('current');});
    t.classList.add('current');slides[i].classList.add('current');
  });
});


/* ---------- promo countdown ---------- */
function tick(){
  var now=new Date();
  var end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0);
  var d=Math.max(0,end-now),h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
  var p=function(n){return (n<10?'0':'')+n;};
  document.getElementById('hours').textContent=p(h);
  document.getElementById('minutes').textContent=p(m);
  document.getElementById('seconds').textContent=p(s);
}
tick();setInterval(tick,1000);

jQuery(document).ready(function($){
    $(document.body).on('click','.dstop,.choice-item', function() {
      var id = $(this).data('juice');
      $('#'+id).addClass('active').siblings().removeClass('active');
      $('[data-benfits="'+id+'"]').addClass('active').siblings().removeClass('active'); 
      $('[data-handle="'+id+'"]').addClass('active').siblings().removeClass('active');
      $('html, body').animate({
            scrollTop: jQuery('#inside').offset().top
        }, 1000); 
    });
    
    $(document.body).on('click','.drink_tabs button', function() {
      var id = $(this).data('handle'); 
      $(this).addClass('active').siblings().removeClass('active');
      $('#'+id).addClass('active').siblings().removeClass('active'); 
      $('[data-benfits="'+id+'"]').addClass('active').siblings().removeClass('active'); 
    });
});